// @ts-strict-ignore
import appleTouchIcon from "@assets/images/logo.png";
import { useUser } from "@dashboard/auth";
import { ShopInfoQuery, useShopInfoQuery } from "@dashboard/graphql";
import React from "react";
import Helmet from "react-helmet";

type ShopContext = ShopInfoQuery["shop"];

export const ShopContext = React.createContext<ShopContext>(undefined);

export const ShopProvider: React.FC = ({ children }) => {
  const { authenticated, user } = useUser();
  const { data } = useShopInfoQuery({
    skip: !authenticated || !user,
  });

  return (
    <>
      <Helmet>
        <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
        <link rel="icon" type="image/png" sizes="32x32" href={appleTouchIcon} />
        <link rel="icon" type="image/png" sizes="16x16" href={appleTouchIcon} />
        <link rel="mask-icon" href={appleTouchIcon} />
      </Helmet>
      <ShopContext.Provider value={data ? data.shop : undefined}>{children}</ShopContext.Provider>
    </>
  );
};

export const Shop = ShopContext.Consumer;
export default Shop;
